<template>
  <div>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <permission name="TollReportUploadCsv">
            <div class="page-title-right">
              <button type="button" class="btn btn-primary float-right" @click="showUploadModal" :disabled="processing">
                <i v-if="processing" class="mdi mdi-loading mdi-spin"></i>
                Lisa raport
              </button>
            </div>
          </permission>
          <h4 class="page-title">Tolliarve kontroll</h4>
        </div>
      </div>
    </div>

    <div class="row" v-if="report">
      <div class="col-md-12 col-xl-12">
        <div class="card mb-3">
          <div class="card-body pb-2">
            <div class="row">
              <div class="col">
                <div class="data-list">
                  <dl>
                    <dt>Deklaratsioone kokku</dt>
                    <dd class="h4"><strong>{{report.settledDeclarationsCount + report.notSettledDeclarationsCount}}</strong></dd>
                  </dl>
                </div>
              </div>
              <div class="col">
                <div class="data-list">
                  <dl>
                    <dt>Korras deklaratsioone</dt>
                    <dd class="h4 text-success"><strong>{{report.settledDeclarationsCount}}</strong></dd>
                  </dl>
                </div>
              </div>
              <div class="col">
                <div class="data-list">
                  <dl>
                    <dt>Tähelepanu vajavaid</dt>
                    <dd class="h4 text-danger"><strong>{{report.notSettledDeclarationsCount}}</strong></dd>
                  </dl>
                </div>
              </div>
              <div class="col">
                <div class="data-list">
                  <dl>
                    <dt>Vanim</dt>
                    <dd class="h5">{{report.oldestDate | formatDate}}</dd>
                  </dl>
                </div>
              </div>
              <div class="col">
                <div class="data-list">
                  <dl>
                    <dt>Uusim</dt>
                    <dd class="h5">{{report.newestDate | formatDate}}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="report.declarations.length" class="card">
          <div class="card-body">
            <h3 class="card-title">Tähelepanu vajavad deklaratsioonid</h3>

            <table class="table table-centered table-sm table-hover table-expandable table-sticky">
              <thead>
              <tr>
                <th>Tolliviide</th>
                <th class="">Maks</th>
                <th class="text-right">Summa</th>
                <th class="text-right">Olek</th>
              </tr>
              </thead>

              <template v-for="declaration in report.declarations">
                <tr class="headline-row">
                  <th>
                    <router-link :to="`/declarations/${declaration.id}`">
                      {{declaration.customsReference}}
                    </router-link>
                  </th>
                  <th colspan="3">
                    {{declaration.clientName}}
                  </th>
                </tr>

                <tr v-for="tax in declaration.taxes">
                  <td></td>
                  <td class="">{{tax.taxName}}</td>
                  <td class="text-right">{{tax.amount | amountWithCurrency}}</td>
                  <td class="text-right">{{$t('TOLL_REPORT.'+tax.status)}}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-info text-center">
          Tähelepanu vajavaid deklaratsioone pole
        </div>
      </div>
    </div>

    <div v-else>
      Raport puudub, lae fail üles
    </div>

    <modal ref="uploadFileModal" title="Vali tolliraporti fail" size="lg">
      <template slot-scope="{visible}" v-if="visible">
        <file-drop v-model="selectedFile" :in-progress="processing" label="Vali fail"></file-drop>
        <button type="button" class="btn btn-primary float-right mt-3" @click="uploadCsv" :disabled="processing || !dataUrl">
          Laadi üles
        </button>
      </template>
    </modal>

  </div>
</template>

<script>
  import Modal from '../components/Modal'
  import FileDrop from '../components/FileDrop'

  export default {
    components: {FileDrop, Modal},
    data() {
      return {
        working: false,
        name: null,
        report: null,
        processing: false,

        dataUrl: null,
        selectedFile: null
      }
    },
    methods: {
      loadData() {
        this.$gateway.get('/reports/toll-report').then(r => this.report = r.data)
      },
      uploadCsv() {
        this.processing = true
        this.$gateway.post('/reports/toll-report', {fileName: this.name, content: this.dataUrl})
          .then(r => {
            this.report = r.data
            this.processing = false
            this.$refs.uploadFileModal.closeModal()
            this.$notifications.info('Tolliraport on töödeldud')
            this.selectedFile = null
            this.dataUrl = null
          })
          .catch(r => {
            this.processing = false
            this.$notifications.error(r.response.data.key)
          })
      },
      showUploadModal() {
        this.$refs.uploadFileModal.show()
      },
      readFile(file) {
        let component = this
        let reader = new FileReader();

        this.fileName = file.name

        const promise = new Promise((resolve, reject) => {
          if (file.size > 20 * 1024 * 1024) {
            reject('Fail on liiga suur. Lubatud on kuni 20 MB')
            return
          }
          reader.onload = () => {
            component.dataUrl = reader.result;
            file.value = ''
            resolve(this.fileName)
          }
        })
        reader.readAsDataURL(file)
        return promise;
      },
    },
    watch: {
      selectedFile(newValue) {
        if (newValue != null)
          this.readFile(newValue).catch(r => this.$notifications.error(r))
      }
    },
    created() {
      this.loadData()
    }
  }

</script>
